// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultSpace__avatar-c39fb0 {
  margin-inline-end: var(--indent-16px);
}

.SearchResultSpace__info-d985cd {
  flex: 1;
  overflow: hidden;
}

.SearchResultSpace__title-wrapper-d24ebd {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.SearchResultSpace__name-d0439d {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SearchResultSpace__members-eb7003 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResultItem/SearchResultSpace/SearchResultSpace.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".avatar {\n  margin-inline-end: var(--indent-16px);\n}\n\n.info {\n  flex: 1;\n  overflow: hidden;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.name {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.members {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `SearchResultSpace__avatar-c39fb0`,
	"info": `SearchResultSpace__info-d985cd`,
	"title-wrapper": `SearchResultSpace__title-wrapper-d24ebd`,
	"titleWrapper": `SearchResultSpace__title-wrapper-d24ebd`,
	"name": `SearchResultSpace__name-d0439d`,
	"members": `SearchResultSpace__members-eb7003`
};
module.exports = ___CSS_LOADER_EXPORT___;
